module.exports = __webpack_public_path__ + "static/media/31.d20edf61.jpg";